function toggleMikalWidget() {
  var btn = document.getElementById("mikalBtn");
  var expanded = document.getElementById("mikalExpanded");
  
  if (expanded.style.display === "block") {
    expanded.style.display = "none";
    btn.style.display = "flex";
  } else {
    expanded.style.display = "block";
    btn.style.display = "none";
  }
}

function initMikalWidget() {
  var widget = document.getElementById("mikal-contact-widget");
  var expanded = document.getElementById("mikalExpanded");
  var btn = document.getElementById("mikalBtn");
  
  // Tjekker om URL'en indeholder '/products/'
  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

  if (widget) {
    function updateVisibility() {
      // Regler for mobil (skærmbredde under 768px)
      if (window.innerWidth <= 768) {
        
        if (isProductPage) {
          // PÅ PRODUKTSIDER: Skjul knappen indtil der scrolles ned over 300px
          if (window.scrollY < 300) {
            widget.classList.add('is-hidden');
            
            // Luk den udvidede boks automatisk, hvis man scroller op
            if (expanded && expanded.style.display === "block") {
              expanded.style.display = "none";
              btn.style.display = "flex";
            }
          } else {
            widget.classList.remove('is-hidden');
          }
        } else {
          // PÅ ALLE ANDRE SIDER: Tving knappen frem!
          widget.classList.remove('is-hidden');
        }
        
      } else {
        // PÅ PC: Tving altid knappen frem!
        widget.classList.remove('is-hidden');
      }
    }
    
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);
    
    // Kør med det samme for at sætte korrekt status
    updateVisibility();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMikalWidget);
} else {
  initMikalWidget();
}